import { render, staticRenderFns } from "./uacAuthentication.vue?vue&type=template&id=2a18121c&scoped=true&"
import script from "./uacAuthentication.vue?vue&type=script&lang=js&"
export * from "./uacAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./uacAuthentication.vue?vue&type=style&index=0&id=2a18121c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a18121c",
  null
  
)

export default component.exports